import React from "react";
import Retweet from "./Components/index";
import { fromDaily, toDaily } from "fuction/date";
import { withRouter } from "react-router";
import queryString from "query-string";
import useAuth from "Hooks/useAuth";

function Page(props) {
  const auth = useAuth();
  const { date, id } = queryString.parse(props.location.search);

  const fromDate = fromDaily(date);
  const toDate = toDaily(date);
  const activeGroup = auth.state.activeGroup;

  const onClickLineChart = (date) => {
    props.history.push(`/retweets/details?activeGroup=${activeGroup}&id=${id}&date=${date}`);
  };
  const handleChangeDateSingle = (date) => {
    props.history.push(`/retweets/daily?activeGroup=${activeGroup}&id=${id}&date=${date}`);
  };

  return (
    <Retweet
      fromDate={fromDate}
      toDate={toDate}
      id={id}
      target="daily"
      unit="hour"
      onClickLineChart={onClickLineChart}
      handleChangeDateSingle={handleChangeDateSingle}
    />
  );
}

export default withRouter(Page);
